export default {
    baseUrl: {
        dev: 'https://back.fryj.top/',
        // dev: 'http://localhost:38080',
        prd: ''
    }
}